var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-set-sub-page layout-sub-page"},[_c('title-bar',{staticClass:"my-set-ui-title-bar",attrs:{"titleData":_vm.titleData,"backFunc":_vm.clickBack}}),_c('my-set-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }